import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { BaseStoreFacade, CityActions } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { AuthRedirectService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, tap, withLatestFrom } from 'rxjs/operators';
import { CityService } from '../services/city.service';

@Injectable()
export class BaseStoreBrowserEffects {
  setActive$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CityActions.SET_ACTIVE_BASE_STORE),
        map(({ payload }) => payload),
        distinctUntilChanged(),
        tap(() => {
          this.authRedirectService.setRedirectUrl(this.location.path(true));
        }),
      ),
    { dispatch: false },
  );

  delayedSetBaseStore$: Observable<CityActions.ClearTemporaryBaseStore | CityActions.SetActiveBaseStore> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        debounceTime(0),
        withLatestFrom(this.baseStoreFacade.getTemporaryBaseStoreCode(), this.baseStoreFacade.getActiveCode()),
        filter(([, tempCode]) => Boolean(tempCode)),
        tap(([, tempCode, code]) => {
          if (code !== tempCode) {
            this.cityService.setBaseStoreWithoutCompareCart(tempCode);
          }
        }),
        map(() => new CityActions.ClearTemporaryBaseStore()),
      ),
  );

  constructor(
    private actions$: Actions,
    private authRedirectService: AuthRedirectService,
    private location: Location,
    private baseStoreFacade: BaseStoreFacade,
    private cityService: CityService,
  ) {}
}
